import React, { useContext, useEffect, useMemo, useState } from "react";
import "./index.scss";
import { getAvailableSidesByStep } from "../../../FormulaGenerator/formulaHelpers";
import Formula3DPreview from "../../../FormulaGenerator/Formula3DPreview";
import { Button, ButtonGroup } from "@mui/material";
import { afterTreatmentFormula, prepareTreatmentFormula } from "../helpers";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const AutoTreatment = ({
  stepId
}) => {
  const {
    _t
  } = useTranslation();
  const {
    beforeTreatmentFormula,
    setStepFormula
  } = useContext(StepContext);
  const availableSwitchers = useMemo(() => {
    return getAvailableSidesByStep(stepId);
  }, [stepId]);
  const [formulaPreview, setFormulaPreview] = useState(null);
  const [formulaPreview2, setFormulaPreview2] = useState(null);
  const [previewType, setPreviewType] = useState("beforeAndAfterTreatment");
  useEffect(() => {
    function togglePreview(type) {
      switch (type) {
        case "beforeTreatment":
          setFormulaPreview(beforeTreatmentFormula);
          setFormulaPreview2(null);
          break;

        case "prepareTreatment":
          setFormulaPreview(prepareTreatmentFormula(beforeTreatmentFormula));
          setFormulaPreview2(null);
          break;

        case "afterTreatment":
          setFormulaPreview(afterTreatmentFormula(beforeTreatmentFormula));
          setFormulaPreview2(null);
          break;

        case "beforeAndAfterTreatment":
          setFormulaPreview(afterTreatmentFormula(beforeTreatmentFormula));
          setFormulaPreview2(beforeTreatmentFormula);
          break;

        case "prepareAndAfterTreatment":
          setFormulaPreview(afterTreatmentFormula(beforeTreatmentFormula));
          setFormulaPreview2(prepareTreatmentFormula(beforeTreatmentFormula));
          break;

        default:
          setFormulaPreview(beforeTreatmentFormula);
          setFormulaPreview2(null);
      }
    }

    togglePreview(previewType);
  }, [beforeTreatmentFormula, previewType]);
  useEffect(() => {
    setStepFormula(stepId, afterTreatmentFormula(beforeTreatmentFormula));
  }, [beforeTreatmentFormula, stepId]);
  const switchers = useMemo(() => {
    return [{
      type: "beforeTreatment",
      title: _t("До лечения")
    }, {
      type: "prepareTreatment",
      title: _t("Подготовка к лечению")
    }, {
      type: "afterTreatment",
      title: _t("После лечения")
    }, {
      type: "beforeAndAfterTreatment",
      title: _t("До и после лечения")
    }, {
      type: "prepareAndAfterTreatment",
      title: _t("Подготовка и после лечения")
    }];
  }, [_t]);
  return /*#__PURE__*/React.createElement("div", {
    className: "autoTreatment"
  }, /*#__PURE__*/React.createElement("div", {
    className: "switchSceneToggle"
  }, /*#__PURE__*/React.createElement("p", {
    className: "switchSceneToggle-title"
  }, _t("Режимы просмотра 3D карты зубов:")), /*#__PURE__*/React.createElement(ButtonGroup, {
    color: "primary",
    className: "switchSceneToggle-container"
  }, switchers.map(el => /*#__PURE__*/React.createElement(Button, {
    key: el.type,
    variant: previewType === el.type ? "contained" : "outlined",
    onClick: () => setPreviewType(el.type)
  }, el.title)))), /*#__PURE__*/React.createElement("div", {
    className: "autoTreatment-3dContainer"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: formulaPreview,
    stlPack2: formulaPreview2,
    availableSwitchers: availableSwitchers,
    hideNotUsedSides: false,
    hideJawStateSwitcher: false,
    jawStateEnabled: false
  })));
};

export default AutoTreatment;